import { combine, createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { model as sessionModel } from '~/entities/session'
import { showsPurchasedEntityModel } from '~/entities/shows/purchased'
import { nay } from '~/shared/helpers'
import { libraryGridPurchasedTvShowsWidget } from '~/widgets/library/grid/purchased/tvShows'
import { $libraryPurchasedTvShowsTranslations } from './translations'

export const initLibraryPurchasedTvShowsPage = createEvent()
export const leftLibraryPurchasedTvShowsPage = createEvent()

sample({
  clock: initLibraryPurchasedTvShowsPage,
  target: libraryGridPurchasedTvShowsWidget.loadGridPurchasedTvShows,
})

export const $isLibraryPurchasedTvShowsEmptyPage = combine(
  showsPurchasedEntityModel.$purchasedTvShowsGrid,
  (purchasedTvShowsGrid) =>
    purchasedTvShowsGrid && !purchasedTvShowsGrid.content.length
)

sample({
  source: leftLibraryPurchasedTvShowsPage,
  target: showsPurchasedEntityModel.resetPurchasedTvShowsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: showsPurchasedEntityModel.resetPurchasedTvShowsGrid,
})

register(
  $libraryPurchasedTvShowsTranslations,
  '$libraryPurchasedTvShowsTranslations'
)
register(
  showsPurchasedEntityModel.$purchasedTvShowsGridFormatted,
  '$library/purchased/tvShows/purchasedTvShowsGridFormatted'
)
register(
  $isLibraryPurchasedTvShowsEmptyPage,
  '$isLibraryPurchasedTvShowsEmptyPage'
)
register(
  libraryGridPurchasedTvShowsWidget.loadMoreGridPurchasedTvShows,
  'loadMoreGridPurchasedTvShows'
)
